/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryTree} from '../models/DictionaryTree';
import type {Error} from '../models/Error';

export interface GetLicenseDataModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseDataModulesRequest = createAction<PayloadData<void>>('GET_LICENSE_DATA_MODULES__GET_LICENSE_DATA_MODULES__REQUEST');
export const getLicenseDataModulesSuccess = createAction<PayloadData<Array<DictionaryTree>>>('GET_LICENSE_DATA_MODULES__GET_LICENSE_DATA_MODULES__SUCCESS');
export const getLicenseDataModulesFailure = createAction<PayloadData<Error, void, true>>('GET_LICENSE_DATA_MODULES__GET_LICENSE_DATA_MODULES__FAILURE');

export const getLicenseDataModulesActions = [
    getLicenseDataModulesRequest,
    getLicenseDataModulesSuccess,
    getLicenseDataModulesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseDataModules = (config?: GetLicenseDataModules$Config) => {
    return {
        CALL_API: {
            types: getLicenseDataModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-data-modules`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

